import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiPost } from "../../api/apiclient"; // Adjust the path to your apiClient.js file
import { LOGIN_ENDPOINT, LOGOUT_ENDPOINT } from "../../api/endpoints";

const initialState = {
  user: null,
  token: null,
  loadingLogin: false,
  loadingLogout: false,
  loadingLogoutSuccess:false,
  error: null,
};

// Async thunk for logging in
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const response = await apiPost(LOGIN_ENDPOINT, { username, password });
      return response.data;
    } catch (error) {
      console.log('error',error)
      return rejectWithValue(error.response?.data?.data?.message || error.message || "Unexpected error occurred.");
    }
  }
);

// Async thunk for logging out
export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiPost(LOGOUT_ENDPOINT);
      return response; // Assuming the API sends a success message
    } catch (error) {
      return rejectWithValue(error.response?.data?.data?.message || error.message || "Unexpected error occurred.");
    }
  }
);



const LoginSliceReducer = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.loadingLogout = false;
      state.error = null;
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
    },
  },
  extraReducers: (builder) => {
    builder
      // Login
      .addCase(loginUser.pending, (state) => {
        state.loadingLogin = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loadingLogin = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
        localStorage.setItem("access_token", action.payload.token); // Store token
        localStorage.setItem("refresh_token", action.payload.refresh_token); // Store refresh token
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loadingLogin = false;
        state.error = action.payload;
      })
      // Logout
      .addCase(logoutUser.pending, (state) => {
        state.loadingLogout = true;
        state.error = null;
        state.loadingLogoutSuccess=false
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.loadingLogout = false;
        state.loadingLogoutSuccess=true
        state.user = null;
        state.token = null;
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.loadingLogout = false;
        state.error = action.payload;
        state.loadingLogoutSuccess =false
      })
  },
});

export const { logout } = LoginSliceReducer.actions;

export default LoginSliceReducer.reducer;
